import { VehicleFilterType } from "@/shared/api-contract/api-contract";
import { Options, setup } from "vue-class-component";
import { Model, Prop, Vue } from "vue-property-decorator";
import CheckBoxList from "@/dashboard/check-box-list/check-box-list.vue";
import RangeSlider from "@/dashboard/range-slider/range-slider.vue";
import ColorFilter from "@/dashboard/color-filter/color-filter.vue";
import { useI18n } from "@/shared/composables/use-i18n";

export enum MainFilterType {
    checkboxList = "checkboxList",
    colorsList = "colorsList",
    rangeSlider = "rangeSlider",
}

@Options({
    components: {
        "app-check-box-list": CheckBoxList,
        "range-slider": RangeSlider,
        "color-filter": ColorFilter,
    },
})
export class MainFilterItem extends Vue {
    i18n = setup(useI18n);

    @Prop({ required: true })
    filter!: VehicleFilterType;

    @Model("modelValue")
    model!: unknown;

    @Prop({ required: true })
    options!: unknown;

    get type(): MainFilterType {
        switch (this.filter) {
            case "availability":
            case "brand":
            case "model":
            case "fueltype":
            case "gearbox":
            case "condition":
                return MainFilterType.checkboxList;
            case "color":
                return MainFilterType.colorsList;
            default:
                return MainFilterType.rangeSlider;
        }
    }

    get rangeUnit(): undefined | string {
        switch (this.filter) {
            case VehicleFilterType.firstregistrationYear:
            case VehicleFilterType.emissionNedc:
            case VehicleFilterType.damage:
                return undefined;
            default:
                return "km";
        }
    }
}
